import { Component, EventEmitter, OnInit, Output, AfterViewInit, HostListener } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslateService } from '@services/translate.service';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { interval, Observable, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { FOOTER_TEXT_KEY, environment, sponsorTsvlLink, gglLinkUrl, darmstadtHessenUrl, mistrzowskiLink, bonusowyLink, happyHoursLink } from '@environments/environment';
import { version } from '@environments/version';
import { projectListType } from '@app/models/environment.model';
import { MatDialog, MatDialogState } from '@angular/material/dialog';
import { SignOutDialog } from '@app/dialogs/sign-out.dialog';
import { reguleminBonusLink, blogLink, reguleminFreeBonusLink } from '@environments/environment';

type footerInformationType = {
  key: string;
  text: string;
  route?: string;
  link?: string;
  isShow: boolean;
  order: number;
  bannedProject: projectListType[];
  target: string;
};

@Component({
  selector: 'footer-component',
  templateUrl: '../sharedTemplates/footer.component.html',
})
export class FooterComponent implements OnInit, AfterViewInit {
  public footerInformationData: footerInformationType[] = [];
  public footerCompanyData: footerInformationType[] = [];
  isMobileView = false;
  private footerInformation: footerInformationType[] = [
    {
      key: 'footer_help_center',
      text: this._TranslateService.instant('footer_help_center'),
      link: environment.helpUrl && environment.helpUrl !== '' ? environment.helpUrl : '',
      isShow: true,
      order: 1,
      bannedProject: environment.helpUrl && environment.helpUrl !== '' ? [] : [environment.product],
      target: '_blank',
    },
    {
      key: 'Addiction_prevention',
      text: this._TranslateService.instant('Addiction_prevention'),
      route: `/article/${this._TranslateService.instant('route_article_footer_1')}`,
      isShow: true,
      order: 2,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'footer_payment_options',
      text: this._TranslateService.instant('footer_payment_options'),
      route: `/payment-details`,
      isShow: true,
      order: 3,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'responsible_gaming',
      text: this._TranslateService.instant('responsible_gaming'),
      route: `/article/${this._TranslateService.instant('route_article_footer_3')}`,
      isShow: true,
      order: 4,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'footer_privacy_cookies',
      text: this._TranslateService.instant('footer_privacy_cookies'),
      route: `/article/${this._TranslateService.instant('route_article_footer_4')}`,
      isShow: true,
      order: 5,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'terms_and_conditions',
      text: this._TranslateService.instant('terms_and_conditions'),
      route: `/article/${this._TranslateService.instant('route_article_footer_5')}`,
      isShow: true,
      order: 6,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'lugas_faq',
      text: this._TranslateService.instant('lugas_faq'),
      route: `/article/${this._TranslateService.instant('route_article_footer_9')}`,
      isShow: true,
      order: 7,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'game_relevant_link',
      text: this._TranslateService.instant('game_relevant_link'),
      link: `${environment.helpUrl}/_2sr12esdt.html`,
      isShow: true,
      order: 8,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'footer_important_link',
      text: this._TranslateService.instant('footer_important_link'),
      link: `${environment.helpUrl}/32sd6sve1.htm`,
      isShow: true,
      order: 8,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'footer_regulamin_bonusu_powitalnego',
      text: this._TranslateService.instant('footer_regulamin_bonusu_powitalnego'),
      link: reguleminBonusLink,
      isShow: false,
      order: 8,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'footer_freebet_regulations',
      text: this._TranslateService.instant('footer_freebet_regulations'),
      link: reguleminFreeBonusLink,
      isShow: false,
      order: 8,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'mistrzowski_freebet',
      text: this._TranslateService.instant('mistrzowski_freebet'),
      link: mistrzowskiLink,
      isShow: false,
      order: 9,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'footer_bonusowy',
      text: this._TranslateService.instant('footer_bonusowy'),
      link: bonusowyLink,
      isShow: false,
      order: 9,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'footer_happyHours',
      text: this._TranslateService.instant('footer_happyHours'),
      link: happyHoursLink,
      isShow: false,
      order: 10,
      bannedProject: [],
      target: '_blank',
    },
    {
      key: 'footer_blog_',
      text: this._TranslateService.instant('footer_blog_'),
      link: blogLink,
      isShow: true,
      order: 11,
      bannedProject: [],
      target: '_blank',
    },
  ];
  private footerCompany: footerInformationType[] = [
    {
      key: 'footer_imprint',
      text: this._TranslateService.instant('footer_imprint'),
      route: `/article/${this._TranslateService.instant('route_article_footer_8')}`,
      isShow: true,
      order: 2,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'route_article_footer_7',
      text: this._TranslateService.instant('AboutUs'),
      route: `/article/${this._TranslateService.instant('route_article_footer_7')}`,
      isShow: true,
      order: 1,
      bannedProject: [],
      target: '_self',
    },
    {
      key: 'franchise',
      text: this._TranslateService.instant('franchise'),
      link: environment.shopLink,
      isShow: true,
      order: 3,
      bannedProject: [],
      target: '_blank',
    },
  ];
  productName = '';
  footerText: { [key: string]: string } = FOOTER_TEXT_KEY;
  langDatas;
  langDatasArry = [];
  selectedLang = '';
  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  VERSION_TEXT = version;

  methodList = this._UiHelper.paymentMethodList
    .filter(x => x.isAvailableFromFooter)
    .filter(x => {
      if (x.availableProject) {
        if (x.availableProject.includes(environment.product)) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
  leagueData = [
    {
      ExtensionData: {},
      CategoryId: 106,
      IsoName: 'de',
      TournamentId: 3793,
      TournamentName: 'Champions League',
      TournamentSportEventCount: 10,
      TournamentText: this._TranslateService.instant('tournament_champions_league'),
    },
    {
      ExtensionData: {},
      CategoryId: 13,
      IsoName: 'de',
      TournamentId: 16,
      TournamentName: 'Bundesliga',
      TournamentSportEventCount: 18,
      TournamentText: this._TranslateService.instant('tournament_bundesliga_1'),
    },
    {
      ExtensionData: {},
      CategoryId: 13,
      IsoName: 'de',
      TournamentId: 80,
      TournamentName: '2nd Bundesliga',
      TournamentSportEventCount: 9,
      TournamentText: this._TranslateService.instant('tournament_bundesliga_2'),
    },
    {
      ExtensionData: {},
      CategoryId: 1,
      IsoName: 'gb',
      TournamentId: 107,
      TournamentName: 'Premier League',
      TournamentSportEventCount: 13,
      TournamentText: this._TranslateService.instant('tournament_premier_league'),
    },
    {
      ExtensionData: {},
      CategoryId: 15,
      IsoName: 'gb',
      TournamentId: 28935,
      TournamentName: 'LaLiga',
      TournamentSportEventCount: 10,
      TournamentText: this._TranslateService.instant('tournament_primera_division'),
    },
    {
      ExtensionData: {},
      CategoryId: 16,
      IsoName: 'tr',
      TournamentId: 133,
      TournamentName: 'Super Lig',
      TournamentSportEventCount: 17,
      TournamentText: this._TranslateService.instant('tournament_superliga'),
    },
    {
      ExtensionData: {},
      CategoryId: 14,
      IsoName: 'it',
      TournamentId: 236,
      TournamentName: 'Serie A',
      TournamentSportEventCount: 19,
      TournamentText: this._TranslateService.instant('tournament_serie_a'),
    },
  ];
  selectedLeagueData = [];
  mainData = [];
  _dayFilter = 300;

  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  state: Subject<string> = new Subject<string>();
  cancel: Observable<string>;

  @HostListener('touchend', ['$event'])
  @HostListener('touchstart', ['$event'])
  onExit() {
    this.state.next('cancel');
  }

  @HostListener('touchstart', ['$event'])
  onHold(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) return '';

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24') return '';

    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');

            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = this._TranslateService.instant(result.message);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                  this.signOut();
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }

  constructor(
    private _router: Router,
    public _LocalizationService: LocalizationService,
    private _ApiService: ApiService,
    public _UserHelper: UserHelper,
    public _UiHelper: UiHelper,
    private _DataHelper: DataHelper,
    private _TranslateService: TranslateService,
    public dialog: MatDialog,
    public _MatDialog: MatDialog
  ) {
    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );
    this.productName = environment?.projectName;
    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }

  ngOnInit() {
    this.footerInformationRebuild('information', this.footerInformation);
    this.footerInformationRebuild('company', this.footerCompany);
  }
  SignOutDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      this._UiHelper.closeAllMenus();
      dialogRef.open(SignOutDialog, {
        width: '350px',
      });
    } else {
      dialogRef.closeAll();
    }
  }
  signOut() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();

        this.refreshAPP();
      })
      .catch(err => console.log('idle.dialog', err));
  }

  refreshAPP() {
    window.location.href = '/home';
  }

  footerInformationRebuild(select: string, informationData: footerInformationType[]): void {
    const showInformationData = informationData.filter(i => i.isShow);
    if (showInformationData.length > 0) {
      const projectControlData = showInformationData.filter((i: footerInformationType) => !i.bannedProject.includes(environment.product));
      if (projectControlData.length > 0) {
        if (select === 'information') {
          this.footerInformationData = projectControlData.sort((a, b) => a.order - b.order);
        } else if (select === 'company') {
          this.footerCompanyData = projectControlData.sort((a, b) => a.order - b.order);
        }
      }
    }
  }

  ngAfterViewInit() {
    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }

  getMatch(tournament) {
    this.selectedLeagueData = [];
    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: tournament.TournamentName,
      SportId: 1,
      SportName: 'Fußball',
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this.mainData, this._dayFilter);
  }

  whatsappLink(): void {
    window.open(`https://wa.me/${environment.whatsappUrl}`, '_blank');
  }

  gglLink(): void {
    window.open(gglLinkUrl, '_blank');
  }

  tsv1860(): void {
    window.open(sponsorTsvlLink, '_blank');
  }
  goToLink(e: string) {
    if (e === 'apple') {
      window.open(environment.appStorelink, '_blank');
    } else {
      window.open(environment.androidPlayLink, '_blank');
    }
  }

  protected readonly gglLinkUrl = gglLinkUrl;
  protected readonly darmstadtHessenUrl = darmstadtHessenUrl;
}
